import { FC, useContext, useEffect } from 'react';
import Header from '../framework/Header';
import { useTranslation } from "react-i18next";
import ErrorMessageView from '../components/ErrorMessage';
import { useLocation } from 'react-router-dom';
import { usePlausibleEvent, usePlausiblePageview } from '../hooks/usePlausibleTracker';
import { AppContext } from '../contexts/AppContext';

/**
 * Render a 404 page
 * @returns {JSX.Element} Component template
 */
const NotFoundView: FC = () => {
  const { t } = useTranslation();
  const { currentLanguage } = useContext(AppContext);
  const location = useLocation();
  usePlausiblePageview({language: currentLanguage});
  const { goal } = usePlausibleEvent()

  // Report page as not found
  useEffect(() => {
    goal('404', { status: 404 } as any)
  }, [goal]);
  
  // Ignore 404 on iframe pages
  if (location.pathname?.includes("iframe")) { return null }

  return (
    <>
      <Header></Header>
      <ErrorMessageView title={t("404.title")} body={t("404.body")}/>
    </>
  );
}

export default NotFoundView;
